(() => {
  const COLLAPSED_HEIGHT = 180;
  const REVIEW_SCROLL_OFFSET = 100;

  const initializeDescription = (root) => {
    if (root.dataset.essDescriptionReady === 'true') return;

    const content = root.querySelector('[data-ess-description-content]');
    const toggle = root.querySelector('[data-ess-description-toggle]');
    if (!content || !toggle || content.scrollHeight <= COLLAPSED_HEIGHT + 1) return;

    root.dataset.essDescriptionReady = 'true';
    root.classList.add('is-collapsible');
    toggle.hidden = false;
  };

  const initializeDescriptions = () => {
    document.querySelectorAll('[data-ess-product-description]').forEach(initializeDescription);
  };

  const openReviewsAndScroll = (event) => {
    const star = event.target.closest('.ess-etrusted-product-star');
    if (!star) return;

    const section = star.closest('.shopify-section') || document;
    const widget = section.querySelector('etrusted-widget[data-etrusted-widget-id]');
    const panel = widget && widget.closest('[data-t4s-tab-content]');
    if (!panel || !panel.id) return;

    event.preventDefault();
    event.stopPropagation();

    const triggers = Array.from(
      section.querySelectorAll(`[data-t4s-tab-item][href="#${panel.id}"]`)
    );
    const visibleTrigger = triggers.find((trigger) => trigger.getClientRects().length > 0);
    const trigger = visibleTrigger || triggers[0];

    if (trigger && !panel.classList.contains('t4s-active')) {
      trigger.click();
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const top = panel.getBoundingClientRect().top + window.scrollY - REVIEW_SCROLL_OFFSET;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initializeDescriptions);
  document.addEventListener('click', openReviewsAndScroll, true);
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-ess-description-toggle]');

    if (toggle) {
      const root = toggle.closest('[data-ess-product-description]');
      const expanded = root.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.querySelector('[data-ess-read-more]').hidden = expanded;
      toggle.querySelector('[data-ess-read-less]').hidden = !expanded;
      return;
    }

    if (event.target.closest('[data-t4s-tab-item]')) {
      requestAnimationFrame(initializeDescriptions);
    }
  });

  if (window.jQuery_T4NT) {
    window.jQuery_T4NT(document).on('variant:changed', (event) => {
      const sku = event.currentVariant && event.currentVariant.sku;
      if (!sku) return;

      document.querySelectorAll('etrusted-widget[data-etrusted-widget-id]').forEach((widget) => {
        widget.setAttribute('data-sku', sku);
      });
    });
  }
})();
